// import { Team } from "src/common-services";
import React from "react";
import PlayerLineupItem from "../../Player/PlayerLineupItem";
import styles from "./styles.scss";

interface BBStartingLineupPositionOrder {
  PG: number;
  SG: number;
  SF: number;
  PF: number;
  C: number;
  [key: string]: number;
}

interface StartingLineupSortOrder {
  NFL: {};
  NBA: BBStartingLineupPositionOrder;
  NCAAB: BBStartingLineupPositionOrder;
  CFB: {};
  MLB: {};
  NHL: {};
  [key: string]: any;
}

const STARTING_LINEUP_LEAGUE_SORT: StartingLineupSortOrder = {
  NFL: {
    QB: 1,
    RB: 2,
    WR: 3,
    LWR: 3,
    SWR: 3,
    RWR: 3,
    TE: 4,
    K: 5,
    FB: 6,
    C: 7,
    G: 8,
    T: 9,
    OT: 10,
    OG: 11,
    OL: 12,
    LB: 13,
    MLB: 14,
    OLB: 15,
    ILB: 16,
    FS: 17,
    SS: 18,
    SAF: 19,
    S: 20,
    CB: 21,
    DB: 22,
    DE: 23,
    DL: 24,
    DT: 25,
    NT: 26,
    D: 27,
    PR: 28,
    P: 29,
  },
  NBA: { PG: 1, SG: 2, SF: 3, PF: 4, C: 5 },
  NCAAB: { PG: 1, SG: 2, SF: 3, PF: 4, C: 5 },
  CFB: {
    QB: 1,
    RB: 2,
    WR: 3,
    LWR: 3,
    SWR: 3,
    RWR: 3,
    TE: 4,
    K: 5,
    FB: 6,
    C: 7,
    G: 8,
    T: 9,
    OT: 10,
    OG: 11,
    OL: 12,
    LB: 13,
    MLB: 14,
    OLB: 15,
    ILB: 16,
    FS: 17,
    SS: 18,
    SAF: 19,
    S: 20,
    CB: 21,
    DB: 22,
    DE: 23,
    DL: 24,
    DT: 25,
    NT: 26,
    D: 27,
    PR: 28,
    P: 29,
  },
  MLB: {
    P: 1,
    C: 2,
    "1B": 3,
    "2B": 4,
    "3B": 5,
    SS: 6,
    LF: 7,
    CF: 8,
    RF: 9,
    DH: 10,
  },
  NHL: {},
};

const offensiveFootballDepth: any = {
  QB: 1,
  RB: 2,
  WR: 3,
  LWR: 4,
  SWR: 5,
  RWR: 6,
  TE: 7,
  K: 8,
  FB: 9,
  C: 10,
  G: 11,
  T: 12,
  OT: 13,
  OG: 14,
  OL: 15,
};

// This mimics the exact sorting strategy we have on mobile
function sortFootballOffensivePlayersByDepth(player1: any, player2: any) {
  if (!offensiveFootballDepth[player1.position] && offensiveFootballDepth[player2.position]) {
    return 1;
  }
  if (offensiveFootballDepth[player1.position] && !offensiveFootballDepth[player2.position]) {
    return -1;
  }
  if (offensiveFootballDepth[player1.position] < offensiveFootballDepth[player2.position]) {
    return -1;
  }
  if (offensiveFootballDepth[player1.position] > offensiveFootballDepth[player2.position]) {
    return 1;
  }
  if (player1.fullName < player2.fullName) {
    return -1;
  }
  if (player1.fullName > player2.fullName) {
    return 1;
  }
  return 0;
}

function sortStartingByLeague(leagueName: string, lineup: []) {
  const uppercaseLeagueName: string = leagueName.toUpperCase();
  if (uppercaseLeagueName === "MLB") {
    lineup.sort((_item1: any, _item2: any) => {
      return _item1.orderRank - _item2.orderRank;
    });
  } else if (uppercaseLeagueName === "NFL" || uppercaseLeagueName === "CFB") {
    lineup.sort((player1: any, player2: any) => {
      return sortFootballOffensivePlayersByDepth(player1, player2);
    });
  } else {
    lineup.sort((_item1: any, _item2: any) => {
      const _item1Order: number = STARTING_LINEUP_LEAGUE_SORT[uppercaseLeagueName][_item1.position] || 1000;
      const _item2Order: number = STARTING_LINEUP_LEAGUE_SORT[uppercaseLeagueName][_item2.position] || 1000;

      if (_item1Order !== _item2Order) {
        return _item1Order - _item2Order;
      }

      const _depthOrder1: number = _item1.player.depthOrder == null ? 1000 : _item1.player.depthOrder;
      const _depthOrder2: number = _item2.player.depthOrder == null ? 1000 : _item2.player.depthOrder;

      return _depthOrder1 - _depthOrder2;
    });
  }
}

const TeamPlayerLineup = ({ leagueName, lineup, team }: { leagueName: any; lineup: any; team: any }) => {
  const validPositions: any = leagueName ? STARTING_LINEUP_LEAGUE_SORT[leagueName.toUpperCase()] : {};

  // filter out the players that are out
  const filteredLineup = (lineup || []).filter((playerLineup: any) => {
    return validPositions[playerLineup.position] !== undefined;
  });

  if (filteredLineup.length === 0) {
    return <div style={{ padding: "20px" }}>Lineup not yet available, please check back later</div>;
  }

  // don't try to sort if we know we dont' have the proper info to do it
  if (leagueName && STARTING_LINEUP_LEAGUE_SORT[leagueName.toUpperCase()]) {
    sortStartingByLeague(leagueName, filteredLineup);
  }

  return filteredLineup.map((playerLineup: any, index: number) => (
    <div className="rotoql-player__item" key={index}>
      <PlayerLineupItem playerLineup={playerLineup} team={team} />
      <style jsx global>
        {styles}
      </style>
    </div>
  ));
};

export default TeamPlayerLineup;
